<template>
  <div class="login">
    <div class="unix-login">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-3">
            <div class="login-content">
              <div class="login-form">
                <h4>Login</h4>
                <form>
                  <div class="form-group">
                    <label>帳號</label>
                    <input
                      id="aips_userid"
                      type="text"
                      class="form-control"
                      placeholder="account"
                      v-model="account"
                    />
                  </div>
                  <div class="form-group">
                    <label>密碼</label>
                    <input
                      id="aips_password"
                      type="password"
                      class="form-control"
                      placeholder="password"
                      v-model="pwd"
                    />
                  </div>
                  <button
                    id="aips_login"
                    type="submit"
                    class="btn btn-primary btn-flat m-b-30 m-t-30"
                    @click.prevent="loginHandler"
                  >Sign in</button>
                </form>
              </div>
              <div id="info">{{ info }}</div>
              <div class="alert alert-info text-center">帳號:user，密碼:0000</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: "",
      account: "",
      pwd: ""
    };
  },
  methods: {
    async loginHandler() {
      const vm = this;
      if (!vm.account || !vm.pwd) return;
      let id = vm.account.toUpperCase();
      let response = await vm.$store.dispatch("LOGIN_HANDLER", {
        id,
        pwd: this.pwd
      });
      if (response) {
        vm.$router.push({ path: "/" });
      } else {
        vm.account = "";
        vm.pwd = "";
        vm.info = "帳號或密碼錯誤！";
        setTimeout(() => {
          vm.info = "";
        }, 2000);
      }
    }
  }
};
</script>

<style>
</style>
